<template>
    <v-container class="secondary-font" style="font-size: 1rem;">
        <active-players v-if="showActivePlayers" @setShowScreen="$emit('setShowScreen', 'live-score')" />
        <div v-else-if="events.length">
            <team-stat-component
                v-if="events[0].type === 'team' && (getTeamEventType(events[0].data) === '2P' || getTeamEventType(events[0].data) === '3P' || getTeamEventType(events[0].data) === '1P')"
                :match="events[0].data"
                :type="getTeamEventType(events[0].data)"
                @updateEvents="updateEvents"
            />
            <compare-stat-component
                v-else-if="events[0].type === 'team'"
                :match="events[0].data"
                :type="getTeamEventType(events[0].data)"
                class="mt-5"
                @updateEvents="updateEvents"
            />
            <player-stat-component
                v-else-if="events[0].type === 'player' && shouldShowPlayerStat(getPlayerEventType(events[0].data))"
                :type="getPlayerEventType(events[0].data)"
                :player="events[0].data"
                @updateEvents="updateEvents"
            />
            <img
                :src="sponsors[Math.floor(Math.random() * 3)]"
                alt="com logo"
                style="position: fixed; bottom: 10px; left: 1470px; height: 200px;"
            >
        </div>
    </v-container>
</template>

<script>
    import TeamStatComponent from '@/components/TeamStatComponent'
    import PlayerStatComponent from '@/components/PlayerStatComponent'
    import CompareStatComponent from '@/components/CompareStatComponent'
    import ActivePlayers from '@/components/ActivePlayers.vue'

    export default {
        components: {
            TeamStatComponent,
            PlayerStatComponent,
            CompareStatComponent,
            ActivePlayers
        },
        props: {
            id: {
                type: String,
                required: true
            },
            showActivePlayers: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com',
                events: [],
                timerEvent: null,
                playerEventSource: null,
                teamEventSource: null,
                sponsors: [
                    require('@/assets/SUNEL-LOGO.jpg'),
                    require('@/assets/SUNEL-LOGO.jpg'),
                    require('@/assets/SUNEL-LOGO.jpg')
                ]
            }
        },
        mounted() {
            // this.initPlayerEventSource()
            this.initTeamEventSource()
        },
        beforeDestroy() {
            // if (this.playerEventSource) this.playerEventSource.close()
            if (this.teamEventSource) this.teamEventSource.close()
        },
        methods: {
            // initPlayerEventSource() {
            //     const url = `${process.env.VUE_APP_API_HOST_DOMAIN}/events/${this.id}/player-subscribe`
            //     this.playerEventSource = new EventSource(url)
            //     this.playerEventSource.addEventListener('player', (event) => {
            //         const evt = { type: 'player', data: JSON.parse(event.data) }
            //         this.events.push(evt)
            //     })
            //     this.playerEventSource.onerror = (error) => {
            //         console.error('Player SSE error:', error)
            //         this.playerEventSource.close()
            //         setTimeout(() => this.initPlayerEventSource(), 1000) // Retry after 1s
            //     }
            // },
            initTeamEventSource() {
                const url = `${process.env.VUE_APP_API_HOST_DOMAIN}/events/${this.id}/team-subscribe`
                this.teamEventSource = new EventSource(url)
                this.teamEventSource.addEventListener('team', (event) => {
                    const evt = { type: 'team', data: JSON.parse(event.data) }
                    this.events.push(evt)
                })
                this.teamEventSource.onerror = (error) => {
                    console.error('Team SSE error:', error)
                    this.teamEventSource.close()
                    setTimeout(() => this.initTeamEventSource(), 1000) // Retry after 1s
                }
            },
            shouldShowPlayerStat(type) {
                if (type === '2P' || type === '3P' || type === '1P') {
                    return true
                } else {
                    this.events.shift()
                    return false
                }
            },
            updateEvents() {
                setTimeout(() => {
                    this.events.shift()
                }, 5000)
            },
            getTeamEventType(teamEvent) {
                if (!teamEvent) return ''
                if (teamEvent.team1.twoPointsMade > 0 || teamEvent.team1.twoPointAttempts > 0 || teamEvent.team2.twoPointsMade > 0 || teamEvent.team2.twoPointAttempts > 0) {
                    return '2P'
                } else if (teamEvent.team1.threePointsMade > 0 || teamEvent.team1.threePointAttempts > 0 || teamEvent.team2.threePointsMade > 0 || teamEvent.team2.threePointAttempts > 0) {
                    return '3P'
                } else if (teamEvent.team1.freeThrowsMade > 0 || teamEvent.team1.freeThrowAttempts > 0 || teamEvent.team2.freeThrowsMade > 0 || teamEvent.team2.freeThrowAttempts > 0) {
                    return '1P'
                } else if (teamEvent.team1.offensiveRebounds > 0 || teamEvent.team2.offensiveRebounds > 0) {
                    return 'T.R.'
                } else if (teamEvent.team1.defensiveRebounds > 0 || teamEvent.team2.defensiveRebounds > 0) {
                    return 'T.R.'
                } else if (teamEvent.team1.assists > 0 || teamEvent.team2.assists > 0) {
                    return 'AST'
                } else if (teamEvent.team1.steals > 0 || teamEvent.team2.steals > 0) {
                    return 'STL'
                } else if (teamEvent.team1.turnovers > 0 || teamEvent.team2.turnovers > 0) {
                    return 'TO'
                } else if (teamEvent.team1.blockedShots > 0 || teamEvent.team2.blockedShots > 0) {
                    return 'BLK'
                }
                return ''
            },
            getPlayerEventType(playerEvent) {
                if (!playerEvent) return ''
                if (playerEvent.twoPointsMade > 0 || playerEvent.twoPointAttempts > 0) {
                    return '2P'
                } else if (playerEvent.threePointsMade > 0 || playerEvent.threePointAttempts > 0) {
                    return '3P'
                } else if (playerEvent.freeThrowsMade > 0 || playerEvent.freeThrowAttempts > 0) {
                    return '1P'
                } else if (playerEvent.rebounds > 0) {
                    return 'rebounds'
                } else if (playerEvent.assists > 0) {
                    return 'assists'
                } else if (playerEvent.steals > 0) {
                    return 'steals'
                } else if (playerEvent.turnovers > 0) {
                    return 'turnovers'
                } else if (playerEvent.blockedShots > 0) {
                    return 'blockedShots'
                }
                return ''
            }
        }
    }
</script>

<style>
    .v-progress-circular__info {
        display: block;
    }
</style>
